
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"14","viewBox":"0 0 16 14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M.728.72a.667.667 0 01.605-.387h13.333a.667.667 0 01.51 1.097L9.998 7.55V13a.667.667 0 01-.964.596l-2.667-1.333a.667.667 0 01-.369-.596V7.55L.824 1.43A.667.667 0 01.728.718zm2.042.947l4.405 5.21c.102.12.158.272.158.43v3.948l1.333.666V7.307c0-.158.056-.31.158-.43l4.405-5.21H2.77z","fill":"#1E1E1E"}})])
          )
        }
      }
    